import { Button, Box, Text } from '@chakra-ui/react';
import { ChatIcon } from '../icons';

interface SidebarSessionButtonProps {
  sessionId: string; // Keep in interface for parent components
  title: string;
  isActive: boolean;
  onClick: () => void;
}

export const SidebarSessionButton = ({ title, isActive, onClick }: SidebarSessionButtonProps) => {
  return (
    <Button
      onClick={onClick}
      display="flex"
      minW={0}
      maxW="full"
      flex={1}
      cursor="pointer"
      alignItems="center"
      gap={3}
      overflow="hidden"
      borderRadius="md"
      bg={isActive ? 'gradientPrimary' : 'primaryLight'}
      p={3}
      pr={10}
      textAlign="left"
      fontSize="sm"
      color="text.inverse"
      fontWeight={isActive ? 'bold' : 'normal'}
      boxShadow={'md'}
      border={'sm'}
      borderColor={'borders.default'}
      transition="all 0.3s"
      _hover={{
        borderColor: 'whiteAlpha.500',
        bg: 'gradientPrimary',
        boxShadow: 'sm',
      }}
    >
      <Box flexShrink={0} color="white">
        <ChatIcon />
      </Box>
      <Text minW={0} flex={1} truncate>
        {title}
      </Text>
    </Button>
  );
};
